import { Roles } from 'src/shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const personnelPaths = {
	default: '',
	root: 'personnel',
	list: 'list',
	detail: ':id',
};

export const personnelFragments = {
	default: [personnelPaths.default],
	root: [personnelPaths.default, personnelPaths.root],
	list: [personnelPaths.default, personnelPaths.root, personnelPaths.list],
	detail: (id: number) => [personnelPaths.default, personnelPaths.root, id],
};

export const personnelDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const personnelDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: {
		roles: personnelDefaultAuthRoles,
	},
};
